export default __webpack_public_path__ + "static/media/exit.ae10428f.svg";